module.exports = __webpack_public_path__ + "static/media/4hours.b2c90ec2.mp4";